export const domain = 'NavBar';

// action types
export const TOGGLE_MAIN_DRAWER = `${domain}/TOGGLE_MAIN_DRAWER`;
export const CLOSE_MAIN_DRAWER = `${domain}/CLOSE_MAIN_DRAWER`;
export const TOGGLE_CART_DRAWER = `${domain}/TOGGLE_CART_DRAWER`;
export const CLOSE_CART_DRAWER = `${domain}/CLOSE_CART_DRAWER`;
export const SHOW_CHIP = `${domain}/SHOW_CHIP`;
export const DELETE_CHIP = `${domain}/DELETE_CHIP`;
